export const environment = {
  PROJECT_ID: 'fusion-ui',
  production: true,
  title: 'Fusion UI',
  recaptcha_key: '6LcraUEUAAAAAHCjEf5VomQ_YVDulKIED4Ty2TGi',
  EnvKeys: {
    CallHomeUrl: `${window.location.hostname}`
  }
};
